import styled, { css, DefaultTheme } from 'styled-components';

import {
  darken,
  rgba,
} from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

const transition = css`
  transition-duration: 500ms;
`;

export const $WizardIndex = styled.span`
  min-width: ${spacing(3.5)};
  display: inline-block;
  text-align: center;

  ${transition};
`;
export const $WizardList = styled.ul`
  padding-left: 0;
  display: flex;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  position: relative;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: -1;
    right: 0;
    width: 100%;
    height: ${spacing('xs')};
    background: ${({ theme }) => darken(0.08, theme.colors.lightGrey)};
  }
`;

interface GetColorArgs {
  $isActive: boolean;
  $isSucceeded: boolean;
  theme: DefaultTheme;
}

const getGreyBackground = ({ theme }: { theme: DefaultTheme }) => {
  return darken(0.08, theme.colors.lightGrey);
};

const getBackground = ({
  theme,
  $isActive,
  $isSucceeded,
}: GetColorArgs): string => {
  if ($isSucceeded) {
    return theme.colors.success;
  }
  if ($isActive) {
    return theme.colors.primary;
  }

  return getGreyBackground({ theme });
};

const getTextColor = ({
  theme,
  $isActive,
  $isSucceeded,
}: GetColorArgs): string => {
  if ($isActive || $isSucceeded) {
    return theme.colors.white;
  }

  return theme.colors.mainTextColor;
};

interface HidingPartProps {
  $isActive: boolean;
  $isCompact: boolean;
  $isSucceeded: boolean;
}

export const $WizardTooltip = styled.div<HidingPartProps>`
  display: block !important;
  width: 100%;
  height: ${spacing('xxl')};
  line-height: ${spacing('xxl')};
  min-width: ${spacing('xxl')};
  padding: 0 ${spacing('sm')};
  position: relative;
  ${transition};

  background-color: ${getBackground};
  border-radius: ${({ theme, $isCompact, $isActive }) =>
    $isCompact && !$isActive ? rem(30 / 2) : theme.borders.radius};

  &::after,
  &::before {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: ${spacing('lg')};
    height: ${spacing('xs')};
    ${transition};
  }
  &::before {
    left: -${spacing('lg')};

    background: linear-gradient(
      to right,
      ${(props) => rgba(getBackground(props), 0)},
      ${(props) => rgba(getBackground(props), 1)}
    );
  }
  &::after {
    right: -${spacing('lg')};
    background: linear-gradient(to right, ${getBackground}, ${getBackground});
  }
`;

export const $WizardItemList = styled.li<HidingPartProps>`
  list-style: none;
  ${transition};

  flex: ${({ $isActive }) => ($isActive ? 1 : 0)};
  color: ${getTextColor};

  & ${$WizardIndex} {
    opacity: ${({ $isSucceeded }) => ($isSucceeded ? 0 : 1)};
  }

  & svg {
    ${transition};
    position: absolute;
    top: 50%;
    left: ${spacing('sm')};
    transform: translateY(-50%);
    opacity: ${({ $isSucceeded }) => ($isSucceeded ? 1 : 0)};
  }

  &:not(:first-child) {
    padding-left: ${spacing('sm')};
  }
  &:not(:last-child) {
    padding-right: ${spacing('sm')};
  }
  position: relative;
  white-space: nowrap;
  font-weight: ${fontWeight('medium')};

  cursor: ${({ $isCompact, $isActive }) =>
    $isCompact && !$isActive ? 'help' : null};
`;

export const $WizardHidingPart = styled.span<HidingPartProps>`
  transition-property: opacity;
  opacity: ${({ $isActive, $isCompact }) => (!$isActive && $isCompact ? 0 : 1)};
  position: ${({ $isCompact }) => ($isCompact ? 'absolute' : null)};
  margin-left: ${spacing('xxs')};
  ${transition};
`;
